import { DatePicker, Space, Typography } from "antd";
import { RangePickerProps } from "antd/lib/date-picker";
import { useEffect, useMemo, useRef, useState } from "react";
import color from "../../../theme/color";
import { GhostCalendar } from "../Icon";
import { IconForm } from "../Icon/index.styled";
import { SelectWrapStyled } from "./Range.styeld";

interface CustomRangePickerProps {
  addOnBefore?: React.ReactNode; // 통합명칭
}

/**
 * 아이콘 커스텀 날짜범위선택
 * @param param0
 * @returns
 */
export const CustomRangePicker: React.FC<
  RangePickerProps & CustomRangePickerProps
> = ({ style, addOnBefore, ...props }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [focus, setFocus] = useState(false);
  const [left, setLeft] = useState(0); // prefix icon (23) + marginleft 4

  /**
   * size에 따른 높이 조절
   * @notice  antdTheme.less 로 기본 작업해야하나.. 찾을 수없어 강제 주입
   */
  const height = useMemo(() => {
    switch (props.size) {
      case "large":
        return 44;
      case "small":
        return 32;
      default:
        return 36;
    }
  }, [props.size]);

  const labelPrefix = useMemo(() => {
    return (
      addOnBefore && (
        <span ref={ref} className="prefix-icon-wrapper">
          <Space size={6} style={{ marginRight: 4 }}>
            <IconForm
              component={GhostCalendar}
              color={color.gray4}
              style={{ fontSize: 13 }}
            />
            {!!props.value?.length && addOnBefore && focus === false && (
              <Typography.Text style={{ fontWeight: 700, color: color.gray4 }}>
                {addOnBefore}
              </Typography.Text>
            )}
          </Space>
        </span>
      )
    );
  }, [props, addOnBefore, focus]);

  useEffect(() => {
    const defaultHeight = props?.value
      ? (props.placeholder?.[0]?.length || 0) * 14
      : 0; // 대충 글자 자릿수 처리

    setLeft(ref?.current?.clientWidth || defaultHeight + 27);
  }, [ref.current, focus, props]);

  return (
    <SelectWrapStyled {...(addOnBefore && { left })}>
      {labelPrefix && labelPrefix}
      <DatePicker.RangePicker
        className={props.value?.length ? "has-values" : undefined}
        suffixIcon={
          addOnBefore ? (
            false
          ) : (
            <IconForm
              component={GhostCalendar}
              style={{ color: color.gray4, fontSize: 13 }}
            />
          )
        }
        separator={props.value || !labelPrefix ? props.separator || "-" : ""}
        style={{ width: "100%", height, ...style }}
        {...props}
        onOpenChange={(open) => {
          setFocus(open);

          return props.onOpenChange;
        }}
      />
    </SelectWrapStyled>
  );
};
